<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="MinusDrillHeightStyle" v-show="dataChart.length || !isDataCenter"></div>
    <noDataSvg :color="editorType === 1 ? '#787A80' : '#787A80'" v-if="!dataChart.length && isDataCenter"/>
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop'
              :option="option"
              :drillClickList="drillClickList"
              :drillDimList="drillDimList"></ChartNav>
    <Pagenation :thisArg="thisArg"></Pagenation>
  </div>
</template>

<script>
import {CHART_TYPE} from "@/option/common/dict";
import util from "@/option/common/util";
import {unref} from "vue";
import {cloneDeep} from "lodash-es";
import noDataSvg from './svg.vue'

export default {
  name: "horizontalBar",
  components: {
    noDataSvg: noDataSvg
  },
  data() {
    return {
      formatter: (params, data) => {
        let content = '';
        if (!this.option.tipContent) {
          this.option.tipContent = ['维度值', '指标名', '指标值']
        }
        if (this.option.tipContent?.includes('维度值')) {
          content += `<div>${params[0].name}</div>`
        }
        params.forEach(item => {
          if (item.value !== undefined) {
            content += '<div>'
            if (this.option.tipContent?.includes('指标名')) {
              content += `${item.seriesName}`
            }
            if (this.option.tipContent?.includes('指标值')) {
              if (this.option.tipContent?.includes('指标名')) {
                content += '：'
              }
              const unit = this.getUnit(item.seriesName)
              content += `${item.value}${unit}`
            }
            content += '</div>'
          }
        })
        return content
      },
      labelFormatter: (params, data) => {
        let content = '';
        if (this.option.labelContent?.includes('维度值')) {
          content += `${params.name}`
        }
        if (this.option.labelContent?.includes('指标值')) {
          if (this.option.labelContent?.includes('维度值')) {
            content += '：'
          }
          const unit = this.getUnit(params.seriesName)
          content += `${params.value}${unit}`
        }
        return content
      }
    }
  },

  computed: {
    isView() {
      return this.$route.name === 'view'
    }
  },
  methods: {
    // 获取单位
    getUnit(name) {
      if (this.prop.metrics) {
        const fieldItem = this.prop.metrics.find(item => item.name === name || item.fieldName === name) || {}
        if (fieldItem?.set?.type === 'percent') {
          return '%'
        }
        return fieldItem?.set?.indexUnit || ''
      } else {
        return ''
      }
    },
    handlerDimParam(param) {
      // 指标环图结构, 辅助指标显示在柱状图复用，通过assistTip字段加一层控制
      param.componentType = this.option.assistTip ? 'indexRingGraph' : undefined;
      return param
    },
    hexColorToRGBA(hex, alpha) {
      const rgb = []; // 定义rgb数组
      if (/^\#[0-9A-F]{3}$/i.test(hex)) {
        // 判断传入是否为#三位十六进制数
        let sixHex = "#";
        hex.replace(/[0-9A-F]/gi, function (kw) {
          sixHex += kw + kw; // 把三位16进制数转化为六位
        });
        hex = sixHex; // 保存回hex
      }
      if (/^#[0-9A-F]{6}$/i.test(hex)) {
        // 判断传入是否为#六位十六进制数
        hex.replace(/[0-9A-F]{2}/gi, function (kw) {
          // eslint-disable-next-line no-eval
          rgb.push(eval("0x" + kw)); // 十六进制转化为十进制并存如数组
        });
        return `rgba(${rgb.join(",")},${alpha / 100})`; // 输出RGB格式颜色
      } else {
        return "rgb(0,0,0)";
      }
    },
    bothSideToolFormatter(params) {
      let res = "";
      params.forEach((v, i) => {
        res += `<div>
                  <div>${i == 0 ? v.name : ""}</div>
                  <div style="display:flex;align-items:center">
                    ${v.marker}
                    <span>${v.seriesName}: ${Math.abs(v.value)} </span>
                  </div>
                </div>`;
      });
      return res;
    },
    updateChart() {
      const {
        chartSet: {
          axisLabelSet = {},
        },
        fontFamily = ''
      } = this.themeCfg
      const optionData = cloneDeep(this.dataChart);
      const {bothSide, assistTip, stack, overturn} = this.option;
      let option = {
        dataZoom: this.getDataZoom(),
        title: this.getOptionTitle(),
        tooltip: {
          ...this.getOptionTip({
            trigger: "axis",
            confine: true
          }),
        },
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(),
        xAxis: this.getXAxisOption({
          data: optionData?.categories || [],
          axisLabel: {
            show: this.validData(this.option.axisLabelShow, true),
            interval: this.option.xAxisInterval || "auto",
            rotate: this.option.xAxisRotate || 0,
            textStyle: {
              color: this.option.xAxisColor || (axisLabelSet?.color || "#fff"),
              fontSize: this.option.xAxisFontSize || (axisLabelSet?.size || 14),
              fontFamily: this.option.xAxisFontFamily || (fontFamily || '微软雅黑')
            },
            formatter: function (value) {
              if (typeof value === "number" && bothSide) {
                return Math.abs(value);
              }
              return value;
            },
          },
        }),
        yAxis: this.getYAxisOption({
          min: this.option.yAxisMinAuto ? null : this.option.yAxisMin,
          max: this.option.yAxisMaxAuto ? null : this.option.yAxisMax,
          interval: this.option.yAxisIntervalAuto ? null : this.option.yAxisInterval,
          minInterval: this.option.yAxisminInterval,
          data: optionData?.categories || [],
          axisLabel: {
            show: this.validData(this.option.yAxisLabelShow, true),
            interval: this.option.yAxisInterval || "auto",
            rotate: this.option.yAxisRotate || 0,
            textStyle: {
              color: this.option.yAxisColor || (axisLabelSet?.color || "#fff"),
              fontSize: this.option.yAxisFontSize || (axisLabelSet?.size || 14),
              fontFamily: this.option.yAxisFontFamily || (fontFamily || '微软雅黑')
            },
            formatter: function (value) {
              if (typeof value === "number" && bothSide) {
                return Math.abs(value);
              }
              return value;
            },
          },
        }),
        series: (() => {
          const barColor = this.option.barColor || [];
          const list = (optionData?.series || []).map((ele, index) => {
            return Object.assign(ele, {
              type: "bar",
              stack: stack ? 'stack' : ele.stack,
              barWidth: this.option.barWidth || 16,
              barMinHeight: this.option.barMinHeight || 0,
              itemStyle: this.getHasProp(
                  !this.switchTheme,
                  {
                    color: this.getColor(index),
                  },
                  {barBorderRadius: this.option.barRadius || 0}
              ),
              label: this.getOptionLabel({
                position: !this.option.category
                    ? this.option.labelPosition
                    : this.option.labelPosition == "top"
                        ? "right"
                        : "inside",
              }),
            });
          });
          return list;
        })(),
      };
      if (this.isDataCenter) {
        let _op = this.getDimentionOption();
        option.yAxis.data = _op.categories;
        option.xAxis.data = _op.categories;
        option.legend = this.getOptionLegend(_op.series);
        // 双边柱状图
        if (bothSide) {
          option.tooltip.formatter = this.bothSideToolFormatter;
        }
        // 辅助指标显示在tooltip
        if (this.prop.assistMetrics && this.prop.assistMetrics.length && assistTip) {
          option.tooltip.formatter = (params) => util.assistMetricsToolFormatter(params, this.prop, this.dataChart, _op.series)
        }
        // 本期同期翻转指标名称为维度
        let renderSeriesList = []
        if (overturn) {
          option.yAxis.data = _op.series.map(item => item.name)
          option.xAxis.data = _op.series.map(item => item.name)
          let categoriesList = [...(_op.categories || [])]
          if (!categoriesList.length || categoriesList.length === 1) {
            categoriesList = _op.series.map(item => item.name)
          }
          categoriesList.forEach((catItem, catIndex) => {
            let obj = {}
            if (!obj.name) {
              obj.name = catItem
            }
            if (!obj.data) {
              obj.data = []
            }
            _op.series.forEach((serItem, serIndex) => {
              if (!_op.categories.length || _op.categories.length === 1) {
                if (catItem === serItem.name) {
                  obj.data[serIndex] = serItem.data[0]
                }
              } else {
                obj.data[serIndex] = serItem.data[catIndex]
              }
            })
            renderSeriesList.push(obj)
          })
          option.legend = this.getOptionLegend(renderSeriesList)
        } else {
          renderSeriesList = _op.series
        }
        option.series = renderSeriesList.map((el, index) => {
          const color = this.option.category ? this.getHorizontalColor(index) : this.getColor(index);
          let d = (index + 1) % 2 == 0 && bothSide
              ? el.data.map((item) => (item?.value !== undefined ? -item.value : -item))
              : el.data.map(item => item?.value !== undefined ? item.value : item)
          return {
            ...el,
            data: d.map((el, index) => {
              return {
                value: el,
                originData: this.getOriginData(optionData, index)
              }
            }),
            type: "bar",
            stack: stack && !el.stack ? "stack" : (el.stack || ''),
            barWidth: this.option.barWidth || 16,
            barGap: (!_op.categories.length || _op.categories.length === 1) && overturn ? '-100%' : undefined, // 本期同期 不拖维度的配置项，控制空数据的bar不占位
            barMinHeight: this.option.barMinHeight || 0,
            itemStyle: this.getHasProp(
                !this.switchTheme,
                {
                  color: color,
                },
                {barBorderRadius: this.option.barRadius || 0}
            ),
            label: this.getOptionLabel({
              position: !this.option.category
                  ? this.option.labelPosition
                  : this.option.labelPosition == "top"
                      ? "right"
                      : "inside",
            }),
            markLine: {
              ...this.getMarkLineDefaultSet(),
              lineStyle: {
                width: this.option.yAxisMarkLineWidth || 1,
                type: this.option.yAxisMarkLineType,
                color: this.option.yAxisMarkLineColor || "#FF0000",
              },
              data: this.option.yAxisMarkLineShow && this.getMarklineOption()
            }
          };
        });
      }
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    },
  },
};
</script>
